/**
 * Shared HTTP helpers for plain REST JSON calls.
 *
 * Use `postJson` for fire-and-forget or imperative REST POSTs (e.g. inside
 * plain async functions with abort controllers). For hook-level REST calls,
 * prefer `useFetchMutation` / `useFetchQuery` from `@opengov/bnp-core`.
 *
 * For Hasura GraphQL calls, use `useGraphQLQuery` / `useGraphQLMutation`
 * from `@opengov/bnp-core` instead.
 */

export async function postJson<TData>(
  url: string,
  body: Record<string, unknown>,
  signal?: AbortSignal
): Promise<TData> {
  const response = await fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    ...(signal ? { signal } : {}),
    body: JSON.stringify(body)
  });
  if (!response.ok) {
    throw new Error(`Request failed: ${response.status} ${response.statusText}`);
  }
  return response.json() as Promise<TData>;
}

export async function getJson<TData>(url: string, signal?: AbortSignal): Promise<TData> {
  const response = await fetch(url, {
    method: 'GET',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    ...(signal ? { signal } : {})
  });
  if (!response.ok) {
    throw new Error(`Request failed: ${response.status} ${response.statusText}`);
  }
  return response.json() as Promise<TData>;
}
